import {useQuery} from "@tanstack/react-query";
import {MIN} from "../util/time-and-date.js";
import {deleteReq, get, post, put} from "./_fetch.js";
import {API_ROUTE_ANNOTATIONS} from "../../../back-end/constants/API-ROUTES.js";

export const useAnnotations = () => {

    const {
        data = [],
        refetch,
    } = useQuery({
        queryKey: ['annotations-api'],
        queryFn: () => get(API_ROUTE_ANNOTATIONS),
        refetchInterval: 5 * MIN,
    })

    const postAnnotation = async postBody => {
        await post(API_ROUTE_ANNOTATIONS, postBody)
        await refetch()
    }

    const updateAnnotation = async putBody => {
        await put(API_ROUTE_ANNOTATIONS, putBody)
        await refetch()
    }

    const deleteAnnotation = async id => {
        if(window.confirm('Confirm annotation delete')){
            await deleteReq(API_ROUTE_ANNOTATIONS, { annotationId: id })
            await refetch()
        }
    }

    return {
        annotations: data,
        postAnnotation,
        updateAnnotation,
        deleteAnnotation,
        refetch,
    }

}